import {Component, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "app/login/login.service";
import {ConclusoesFichasModel} from "./conclusoes-fichas.model";
import {ConclusoesFichasService} from "./conclusoes-fichas.service";

declare let swal: any;

@Component({
  selector: 'app-conclusoes-fichas',
  templateUrl: './conclusoes-fichas.component.html'
})
export class ConclusoesFichasComponent extends Components implements OnInit {

  conclusoes: ConclusoesFichasModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private conclusoesFichasService: ConclusoesFichasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'fichas'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.conclusoesFichasService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.conclusoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.conclusoes);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  delete(conclusao) {
    let conclusoes = this.conclusoes;
    let conclusoesFichasService = this.conclusoesFichasService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarConclusao')+conclusao.conclusao_pt,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(conclusoes);
        }

        let index = conclusoes.indexOf(conclusao);
        conclusoes.splice(index, 1);

        conclusoesFichasService.apagar(conclusao.id_conclusao)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.conclusoes = conclusoes;
            },
            err => {
              // Revert the view back to its original state
              conclusoes.splice(index, 0, conclusao);
              self.conclusoes = conclusoes;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.conclusoesFichasService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.conclusoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/conclusoes-fichas/conclusoes-fichas.component.ts